import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { TID } from "../constants/testIds";
import { toast, Toaster } from "sonner";

const AdminLogin = () => {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail;
      toast.error(typeof msg === "string" ? msg : "Anmeldung fehlgeschlagen");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <Toaster position="top-center" theme="light" />
      <form onSubmit={submit} className="w-full max-w-md card-academy rounded-xl p-8 space-y-5">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-primary mb-2">Admin</div>
          <h1 className="font-serif-display text-3xl">KK Academy Verwaltung</h1>
          <p className="text-muted-foreground text-sm mt-2">Bitte melde dich an.</p>
        </div>
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-muted-foreground mb-2">E-Mail</label>
          <input required type="email" value={email} onChange={e => setEmail(e.target.value)}
            data-testid={TID.adminEmail}
            className="w-full bg-input/30 border border-border rounded-md px-4 py-3 text-sm focus:outline-none focus:border-primary" />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-muted-foreground mb-2">Passwort</label>
          <input required type="password" value={password} onChange={e => setPassword(e.target.value)}
            data-testid={TID.adminPassword}
            className="w-full bg-input/30 border border-border rounded-md px-4 py-3 text-sm focus:outline-none focus:border-primary" />
        </div>
        <button disabled={loading} type="submit" data-testid={TID.adminLoginBtn} className="w-full py-3 rounded-full font-medium btn-gold disabled:opacity-50">
          {loading ? "…" : "Anmelden"}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
